import 'slick-carousel'
const { default: loadHtml } = require("./plugins/load-html")
const [ w, d, l ] = [ window, document, location ]
w.load = {}

const slider = {
  obj:'[data-plugin="slider"]',
  init() {
    $(this.obj).slick({
      autoplay:true,
      fade: true,
      dots: false,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
  }
}

const mainvisual_init = () => {
  if( d.querySelectorAll( slider.obj ).length != 0  ) slider.init()
}

const init = () => {
  loadHtml(d.querySelectorAll('[data-load-html]'))
  if( l.pathname == '/' ) $.when( w.load['loadHtml'] ).then( mainvisual_init )
	if( d.documentElement.classList.contains('ui-mobile') ) $('.footer_menu').append(`<li><a href="/information/?mode=detail&article=15" rel="external" class="ui-link">特定商取引法に基づく表示</a></li>`)
}

$(() => init() )